export default "__VITE_ASSET__e934e516__"